import { useParams, Link } from "react-router-dom";
import { insightBySlug, insights } from "../data/insights";
import { getHead } from "../seo/routes";
import { Seo } from "../components/Seo";
import { CTABand, Breadcrumbs } from "../components/Blocks";
import { formatDate } from "../utils/date";
import NotFound from "./NotFound";

export default function InsightPage() {
  const { slug } = useParams();
  const article = insightBySlug[slug];
  if (!article) return <NotFound />;
  const path = `/insights/${article.slug}`;
  const head = getHead(path, { article });
  const more = insights.filter((a) => a.slug !== article.slug).slice(0, 3);
  return (
    <>
      <Seo title={head.title} description={head.description} path={path} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Insights", to: "/insights" }, { label: article.title }]} />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="insight-article">
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#FF5500]">Maze Security Insights · {formatDate(article.date)}</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight uppercase leading-none text-white">{article.title}</h1>
        <p className="mt-5 text-lg text-gray-300 leading-relaxed">{article.excerpt}</p>
        <div className="mt-8" />
        <div className="mt-10 space-y-10">
          {article.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">{s.h}</h2>
              <p className="mt-3 text-base text-gray-400 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
      </article>
      <CTABand title="Talk to a Security Coordinator" sub="Every site is different. Call our 24/7 dispatch or email us about your property — practical advice, no obligation." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="more-insights">
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight uppercase text-white mb-8">More from the Briefing Room</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {more.map((a) => (
            <Link key={a.slug} to={`/insights/${a.slug}`} data-testid={`more-insight-${a.slug}`} className="group border border-white/10 bg-[#181C28] rounded-sm p-5 transition-all duration-200 hover:-translate-y-1 hover:border-[#FF5500]/50">
              <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-[#FF5500]">{formatDate(a.date)}</p>
              <h3 className="mt-2 font-display text-lg font-bold tracking-tight text-white group-hover:text-[#FF5500] transition-colors">{a.title}</h3>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
